import { type ComponentProps, memo } from 'react'

import { ButtonRoot } from '@/components/common/Button'
import { FloatingTooltip } from '@/components/common/Floating'
import { Icon } from '@/components/icons/Icon'
import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { type RecType } from '@/defs/rec'
import { cn } from '@/utils/commonUtil'

import { useCardFlags } from '../hooks/useCardFlags'

import styles from './CardFlags.module.scss'

type ButtonProps = ComponentProps<typeof ButtonRoot>

type Props = {
  controls?: 'left' | 'right'
  rec: RecType
  size?: 'sm'
}

const CardFlagsInner = ({ controls, rec, size }: Props) => {
  const flags = useCardFlags({ rec })

  return (
    flags.length > 0 && (
      <div className={cn(styles.container, { controls, size, styles })}>
        <ul className={styles.list}>
          {flags.map(({ flag, icon, label, labelLink, labelShort, textIcon }) => {
            const buttonProps: ButtonProps = labelLink ? { as: 'LinkOutbound', href: labelLink, utm: false } : {}

            return (
              <li key={flag}>
                <FloatingTooltip content={<IconWithLabel iconBefore={icon}>{label}</IconWithLabel>} placement='right'>
                  <ButtonRoot
                    {...buttonProps}
                    aria-label={!textIcon ? labelShort : undefined}
                    className={cn(styles.flag, { styles, textIcon, variant: flag })}
                  >
                    {textIcon ? <span>{labelShort}</span> : <Icon name={icon} />}
                  </ButtonRoot>
                </FloatingTooltip>
              </li>
            )
          })}
        </ul>
      </div>
    )
  )
}

export const CardFlags = memo(CardFlagsInner)
